import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PasoWizard} from "../../interface/wizard-informacion.types";
import {ButtonControlService} from '../../services/button-control.service';

@Component({
    selector: 'lib-buttons',
    templateUrl: './buttons.component.html',
    styleUrls: ['./buttons.component.css']
})
export class ButtonsComponent implements OnInit, OnDestroy {

    @Input()
    pasos: PasoWizard[];

    @Input()
    pasosTotal = 0;

    @Input()
    currentStep = 0;

    @Output()
    goToPreviousStep: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    goToNextStep: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    goToSave: EventEmitter<any> = new EventEmitter<any>();

    disableSaveBtn = false;
    disableNext = true;

    @Input()
    isLoading = "";

    constructor(
        private buttonControlService: ButtonControlService,
    ) {
        this.buttonControlService.botonSiguiente.subscribe(response => {
            this.disableNext = !response;
        })
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.buttonControlService.stopSubscriptions();
    }

    goToNext() {
        if (this.checkStepCurrent()) {
            // emit events save
            this.goToSave.emit();
        } else {
            this.goToNextStep.emit();
        }
    }

    checkStepCurrent() {
        return this.currentStep + 1 == this.pasosTotal;
    }
}
